import { CardSortingCategories, ClosableHint } from '@components';
import { useScrollToTop } from '@hooks';
import { Flex } from '@styles';
import { func, object } from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FinishCard } from 'src/components/CardMatching/components';

const SortLayout = ({ onFinish, sort }) => {
  const { t } = useTranslation();
  const [areCardsSorted, setAreCardsSorted] = useState(false);
  const [isHintOpen, setIsHintOpen] = useState(true);
  const [wrongChoicesAmount, setWrongChoicesAmount] = useState(0);

  const handleSortFinish = () => {
    setAreCardsSorted(true);
  };

  useScrollToTop();

  const handleHintClose = () => setIsHintOpen(false);
  const onError = () => {
    setWrongChoicesAmount((prevState) => prevState + 1);
  };

  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!sort) return <></>;

  return (
    <Flex flexDirection="column" gap={24}>
      <ClosableHint
        isOpen={isHintOpen}
        onClose={handleHintClose}
        text={
          <>
            <b>{t('DragAndDropHint.DragAndDrop')}: </b>
            {t('DragAndDropHint.Description')}
          </>
        }
      />
      {!areCardsSorted ? (
        <CardSortingCategories
          categories={sort.categories}
          items={sort.items}
          onError={onError}
          onFinish={handleSortFinish}
        />
      ) : (
        <FinishCard
          onFinishButtonPress={onFinish}
          status={wrongChoicesAmount ? 'fail' : 'success'}
          withContinue
        />
      )}
    </Flex>
  );
};

SortLayout.propTypes = {
  onFinish: func.isRequired,
  sort: object.isRequired,
};

export default SortLayout;
